import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Dashboard from "../components/Views/Dashboard/Dashboard";
import PersistLogin from "../components/Auth/PersistLogin";

import Authorization from "../components/Auth/Authorization";
import Unauthorized from "../components/Auth/Unauthorized";
import UserVerifyOtp from "../components/Auth/UserVerifyOtp";
import Logout from "../components/Views/Login/Logout";
import Login from "../components/Views/Login/Login";

import Signin from "../components/Auth/Signin";
import Customer from "../components/Views/Customer/Customers";
import PackagesList from "../components/Views/Package/PackagesList";
import CustomerProfile from "../components/Views/Customer/CustomerProfile";
import CreatePackage from "../components/Views/Package/CreatePackage";
import Employee from "../components/Views/Setting/Employee";
import AddEmployee from "../components/Settings/Employee/AddEmployee";
import Accounts from "../components/Views/Accounts/Accounts";
import Promos from "../components/Views/Setting/Promos";
import useAuth from "../hooks/useAuth";
import Cookies from "universal-cookie";
import DeleteAccount from "../components/DeleteAccount/DeleteAccount";

const PupRoutes = () => {
  const { auth } = useAuth();

  const cookies = new Cookies();

  let getKey = false;
  if (cookies.get("ulid_D_P") != undefined) {
    getKey = true;
  } else {
    getKey = false;
  }

  return (
    <Router>
      <Routes>
        <Route path="/user/deleteAccount" element={<DeleteAccount />} />
        <Route
          path="/"
          element={
            getKey ? <Navigate to="/dashboard" /> : <Navigate to="/login" />
          }
        />
        <Route
          path="/login"
          element={getKey ? <Navigate to="/dashboard" /> : <Login />}
        />
        {/* <Route path="/" element={<Dashboard />} />
        <Route path="/login" element={<Login />} /> */}
        <Route path="/logout" element={<Logout />} />

        {/*<Route*/}
        {/*    path="/login"*/}
        {/*    element={*/}
        {/*      auth.accessToken ? <Navigate to="/dashboard" /> :<Login />}/>*/}
        {/*<Route path="/" element={auth.accessToken ? <Navigate to="/dashboard"/>:<Navigate to="/login"/>} />*/}
        {/*/!* </Route> *!/*/}
        <Route path="/verify" element={<UserVerifyOtp />} />

        {/*<Route path="*" element={getKey ? <Unauthorized /> : <Navigate to="/login" />} />*/}
        <Route
          path="*"
          element={
            getKey ? <Navigate to="/dashboard" /> : <Navigate to="/login" />
          }
        />
        <Route element={getKey ? <PersistLogin /> : <Navigate to="/login" />}>
          <Route element={<Authorization />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/customers" element={<Customer />} />
            <Route path="/addCustomer" element={<CreatePackage />} />
            <Route
              path="/customerProfile/:user_id"
              element={<CustomerProfile />}
            />
            <Route path="/packages" element={<PackagesList />} />
            {/* <Route path="/CreatePackage" element={<CreatePackage/>}/> */}
            {/*<Route path="setting" element={<Settings/>}/>*/}
            <Route path="/accounts" element={<Accounts />} />
            <Route path="/employee" element={<Employee />} />
            <Route path="/addEmployee" element={<AddEmployee />} />
            {/*<Route path="/promos" element={<Promos/>}></Route>*/}
          </Route>
        </Route>
      </Routes>
    </Router>
  );
};

export default PupRoutes;
